import React from 'react';
import RuleEditorGeneral from './rule-editor-general/rule-editor-general';
import { RuleTabs } from 'src/utils/enums';
import { EditableRule } from 'src/model/EditableRule';
import { RuleEditorApplications } from './rule-editor-applications/rule-editor-applications';
import RuleEditorZone from './rule-content-zone/rule-content-zone';
import RuleEditorServices from './rule-editor-services/rule-editor-services';
import { getErrorsBySection, TabsErrors } from 'src/dtos/error-message.dto';
import { RuleEditorProfiles } from './rule-editor-profiles/rule-editor-profiles';

interface RuleEditorContentProps {
    activeMenu: RuleTabs;
    ruleData: EditableRule;
    ruleErrors: TabsErrors;
    ruleCount: number;
    handleChange: (name: any, value: any) => void;
    handleRuleChange: (updatedRule: Partial<EditableRule>) => void;
    allowDns: boolean;
}

const RuleEditorContent: React.FC<RuleEditorContentProps> = ({
                                                                 activeMenu,
                                                                 ruleData,
                                                                 ruleCount,
                                                                 ruleErrors,
                                                                 handleChange,
                                                                 handleRuleChange,
                                                                 allowDns
                                                             }) => {
    switch (activeMenu) {
        case RuleTabs.GENERAL:
            return (
                <RuleEditorGeneral
                    ruleData={ruleData}
                    ruleCount={ruleCount}
                    sectionErrors={getErrorsBySection(ruleErrors, RuleTabs.GENERAL)}
                    handleRuleChange={handleRuleChange}
                />
            );
        case RuleTabs.SOURCE:
            return <RuleEditorZone
                ruleData={ruleData}
                sectionErrors={getErrorsBySection(ruleErrors, RuleTabs.SOURCE)}
                handleChange={handleChange}
                type={'src'}
                handleRuleChange={handleRuleChange}
            />;
        case RuleTabs.DESTINATION:
            return <RuleEditorZone
                ruleData={ruleData}
                sectionErrors={getErrorsBySection(ruleErrors, RuleTabs.DESTINATION)}
                handleChange={handleChange}
                type={'dst'}
                handleRuleChange={handleRuleChange}
            />;
        case RuleTabs.SERVICES:
            return <RuleEditorServices
                        ruleData={ruleData}
                        sectionErrors={getErrorsBySection(ruleErrors, RuleTabs.SERVICES)}
                        handleRuleChange={handleRuleChange} />;
        case RuleTabs.APPLICATIONS:
            return <RuleEditorApplications
                ruleData={ruleData}
                sectionErrors={getErrorsBySection(ruleErrors, RuleTabs.APPLICATIONS)}
                handleRuleChange={handleRuleChange}
            />;
        case RuleTabs.PROFILES:
            return <RuleEditorProfiles
                ruleData={ruleData}
                handleChange={handleChange}
                allowDns={allowDns}
            />;
    }
    return <></>;
};

export default RuleEditorContent;